import { Vehicle } from "./types";

export const mockVehicles: Vehicle[] = [
  {
    id: "1",
    plate: "CVWD...",
    class: "A",
    model: "Maz...",
    driver: "Ajay Gopal Periyadan Ka...",
    status: "Online",
    location: { lat: 25.7617, lng: -80.1918 }
  },
  {
    id: "2",
    plate: "KALYA...",
    class: "A",
    model: "Hyu...",
    driver: "Rajveer Singh",
    status: "Online",
    location: { lat: 25.7707, lng: -80.1937 }
  },
  {
    id: "3",
    plate: "CVBM9...",
    class: "A",
    model: "Hyu...",
    driver: "Gajendrasinh Chavda",
    status: "Active",
    location: { lat: 25.7657, lng: -80.1858 }
  },
  {
    id: "4",
    plate: "CYJR779",
    class: "A",
    model: "Toyo...",
    driver: "Mustafa Can Doganay",
    status: "Online",
    location: { lat: 25.7797, lng: -80.2008 }
  },
  {
    id: "5",
    plate: "DKR773",
    class: "A",
    model: "Maz...",
    driver: "Vidita Upadhyay",
    status: "In-ride",
    location: { lat: 25.7747, lng: -80.1978 }
  },
  {
    id: "6",
    plate: "CXWH...",
    class: "A",
    model: "Hon...",
    driver: "Jacob George",
    status: "Online",
    location: { lat: 25.7587, lng: -80.1888 }
  },
  {
    id: "7",
    plate: "DEXF8...",
    class: "A",
    model: "Toyo...",
    driver: "Chibueze Ikeh",
    status: "Online",
    location: { lat: 25.7677, lng: -80.1998 }
  },
  {
    id: "8",
    plate: "KRISV...",
    class: "A",
    model: "Hyu...",
    driver: "Shiv Vadalia",
    status: "Online",
    location: { lat: 25.7727, lng: -80.1848 }
  },
  {
    id: "9",
    plate: "BALT...",
    class: "A",
    model: "Nis...",
    driver: "Bharat Singh",
    status: "Active",
    location: { lat: 25.7837, lng: -80.1928 }
  },
  {
    id: "10",
    plate: "MEXR45",
    class: "A",
    model: "Ford...",
    driver: "Carlos Martinez",
    status: "In-ride",
    location: { lat: 25.7557, lng: -80.1958 }
  }
];

// Add more vehicles for a total of ~100
for (let i = 11; i <= 100; i++) {
  const statuses: Vehicle["status"][] = ["Online", "Activating", "Active", "In-ride", "Issues"];
  const models = ["Maz...", "Hyu...", "Toyo...", "Hon...", "Nis...", "Ford...", "Chev..."];
  const names = [
    "Michael Johnson", "Sarah Williams", "David Brown", "Emma Davis",
    "James Wilson", "Olivia Moore", "Robert Taylor", "Sophia Anderson",
    "William Thomas", "Isabella Jackson", "John White", "Mia Harris"
  ];
  
  mockVehicles.push({
    id: `${i}`,
    plate: `VEH${i}${String.fromCharCode(65 + (i % 26))}`,
    class: "A",
    model: models[i % models.length],
    driver: names[i % names.length],
    status: statuses[i % statuses.length],
    location: {
      lat: 25.7617 + (Math.random() - 0.5) * 0.05,
      lng: -80.1918 + (Math.random() - 0.5) * 0.05
    }
  });
}